import { useEffect } from 'react';

export const useLazyBackground = (className = 'lazy-background') => {
  useEffect(() => {
    const lazyBackgrounds = document.querySelectorAll(`.${className}`);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const target = entry.target;
            const bgUrl = target.dataset.bg || '';

            if (bgUrl) {
              target.style.backgroundImage = `url('${bgUrl}')`;
              target.classList.add('loaded');
            }

            obs.unobserve(target);
          }
        });
      });

      lazyBackgrounds.forEach(bg => observer.observe(bg));
    } else {
      lazyBackgrounds.forEach(bg => {
        const target = bg;
        const bgUrl = target.dataset.bg || '';

        if (bgUrl) {
          target.style.backgroundImage = `url('${bgUrl}')`;
          target.classList.add('loaded');
        }
      });
    }
  }, [className]);
};
